import { AbstractControl, ValidatorFn, FormGroup } from '@angular/forms';

export class CustomValidators {
  static emailValidatorRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  static passwordValidatorRegex = /^(?=.*[a-zA-Z0-9]).{6,}$/;
  static phoneNumberValidatorRegex = /^[0-9]+$/;
  constructor() {}

  // Only for char

  static onlyAlphabetsValidator(controlName: string): ValidatorFn {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      if (!control.value) {
        return null;
      }

      if (control.errors && !control.errors['CustomError']) {
        return null;
      }

      const valid = /^[a-zA-Z]*$/.test(control.value);
      if (!valid) {
        control.setErrors({ CustomError: true });
      } else {
        control.setErrors(null);
      }
      return null;
    };
  }

  // confirm password

  static confirmPasswordValidator(
    controlName: string,
    matchingControlName: string
  ) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors['CustomError']) {
        return;
      }

      if (!matchingControl.value) {
        return null;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ CustomError: true });
      } else {
        matchingControl.setErrors(null);
      }
      return null;
    };
  }

  static emailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (!control.value) return null;

      if (this.emailValidatorRegex.test(String(control.value).toLowerCase())) {
        return null;
      } else {
        return { pattern: true };
      }
    };
  }

  static passwordValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (!control.value) return null;

      if (this.passwordValidatorRegex.test(control.value)) {
        return null;
      } else {
        return { pattern: true };
      }
    };
  }

  // social media link validation
  static urlValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      const urlPattern = /^(ftp|http|https):\/\/[^ "]+$/;
      if (!urlPattern.test(value)) {
        return { CustomError: true };
      }
      return null;
    };
  }

  // Phone Number Validation
  static PhoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (!value) {
        return null;
      }

      if (!this.phoneNumberValidatorRegex.test(value)) {
        return { CustomError: true };
      }
      return null;
    };
  }

  // Image Validator
  static imageTypeValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const file = control.value;
      if (file) {
        const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
        if (!allowedTypes.includes(file.type)) {
          return { invalidImageType: true };
        }
      }
      return null;
    };
  }

  // Zip Validator
  static zipCodeValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      const regex = /^[a-zA-Z0-9]*$/;
      if (!regex.test(value)) {
        return { CustomError: true };
      }
      return null;
    };
  }

  // Instagram Validator
  static instagramIdValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      const urlPattern =/^(?:@)(?!.*-)[a-z0-9_](?:(?:[a-z0-9_]|(?:\.(?!\.))){0,28}(?:[a-z0-9_]))?$/;
      if (!urlPattern.test(value)) {
        return { CustomError: true };
      }
      return null;
    };
  }

  // Facebook Validator
  static facebookValidator(): ValidatorFn{
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      const urlPattern =/^(?!.*\.(com|net|org|info|biz|edu|gov|mil|int|mobi|name|pro|xxx|jobs|travel|aero|coop|museum|cat|us|uk|ca|au|de|fr|jp|cn|in|ru|br|mx|it|es|nl|se|ch|no|dk|fi|be|at|gr|pt|cz|hu|pl|ro|sk|ua)$)(?!.*\.\.)[a-zA-Z][a-zA-Z0-9._]*[a-zA-Z0-9]$/;
      if (!urlPattern.test(value)) {
        return { CustomError: true };
      }
      return null;
    };
  }

  // TikTok Validator
  static tikTokValidator(): ValidatorFn{
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      const urlPattern =/^(?!.*\.\.)(?!.*__)[a-zA-Z0-9][a-zA-Z0-9_.]*[a-zA-Z0-9]$/;
      if (!urlPattern.test(value)) {
        return { CustomError: true };
      }
      return null;
    };
  }

  // Twitter Validator 
  static twitterValidator(): ValidatorFn{
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (!value) {
        return null;
      }
      const urlPattern =/^[a-zA-Z0-9_]+$/;
      if (!urlPattern.test(value)) {
        return { CustomError: true };
      }
      return null;
    };
  }
}
